<template>
  <div>
    <hollow-dots-spinner
      :animationDuration="750"
      :dotSize="12"
      :dotsNum="3"
      :color="color"
    />
  </div>
</template>

<script>
import {HollowDotsSpinner} from "epic-spinners";

export default {
  name: "Loader",
  components: {
    HollowDotsSpinner,
  },
  props: {
    color: {
      type: String,
      default: '#723BE3'
    }
  }
}
</script>
